// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea-module__textarea__1vHwn"};